import React, { useState, useEffect } from 'react';
import config from '../Config';
import Topbar from '../Components/Topbar';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function City() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    city: '',
    active: true
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchCities();
  }, []);

  const fetchCities = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.apiUrl}/api/v1/admin/serviceable-cities?disable_pagination=true`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (response.ok) {
        setCities(data || []); // Changed from data.data to data since response is direct array
      } else {
        setError(data.message || 'Failed to fetch cities');
      }
    } catch (err) {
      setError('Failed to fetch cities');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const url = isEditing 
        ? `${config.apiUrl}/api/v1/admin/serviceable-cities/${editingId}`
        : `${config.apiUrl}/api/v1/admin/serviceable-cities`;
      
      const response = await fetch(url, {
        method: isEditing ? 'PUT' : 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(isEditing ? 'City updated successfully' : 'City created successfully');
        setShowModal(false);
        fetchCities();
        resetForm();
      } else {
        toast.error(data.message || 'Operation failed');
      }
    } catch (err) {
      toast.error('Operation failed');
    }
  };

  const handleEdit = (city) => {
    setFormData({
      city: city.city,
      active: city.active
    });
    setEditingId(city.id);
    setIsEditing(true);
    setShowModal(true);
  };

  // const handleDelete = async (id) => {
  //   if (window.confirm('Are you sure you want to delete this city?')) {
  //     try {
  //       const token = localStorage.getItem('token');
  //       const response = await fetch(`${config.apiUrl}/api/v1/admin/serviceable-cities/${id}`, {
  //         method: 'DELETE',
  //         headers: {
  //           'Authorization': `Bearer ${token}`
  //         }
  //       });

  //       if (response.ok) {
  //         toast.success('City deleted successfully');
  //         fetchCities();
  //       } else {
  //         const data = await response.json();
  //         toast.error(data.message || 'Failed to delete city');
  //       }
  //     } catch (err) {
  //       toast.error('Failed to delete city');
  //     }
  //   }
  // };

  const resetForm = () => {
    setFormData({
      city: '',
      active: true
    });
    setIsEditing(false);
    setEditingId(null);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Topbar />
      <ToastContainer />

      <main className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Cities</h1>
          <button
            onClick={() => {
              resetForm();
              setShowModal(true);
            }}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
          >
            Add New City
          </button>
        </div>

        {loading ? (
          <div>Loading...</div>
        ) : error ? (
          <div className="text-red-600">{error}</div>
        ) : (
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">City</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {cities.map((city) => (
                  <tr key={city.id} className="hover:bg-gray-50">
                    <td className="text-left px-6 py-4">{city.city}</td>
                    <td className="text-left px-6 py-4">
                      <span className={`px-2 py-1 rounded-full text-xs ${city.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                        {city.active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td className="text-left px-6 py-4">
                      <button
                        onClick={() => handleEdit(city)}
                        className="text-indigo-600 hover:text-indigo-900 mr-4"
                      >
                        Edit
                      </button>
                      {/* <button
                        onClick={() => handleDelete(city.id)}
                        className="text-red-600 hover:text-red-900"
                      >
                        Delete
                      </button> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showModal && (
          <div className="fixed inset-0 z-[120] bg-gray-500 bg-opacity-75 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg p-6 sm:p-8 max-w-md w-full max-h-[90dvh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">
                  {isEditing ? 'Edit City' : 'Add New City'}
                </h2>
                <button
                  onClick={() => {
                    setShowModal(false);
                    resetForm();
                  }}
                  className="text-gray-500 hover:text-gray-700"
                >
                  ✕
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    City Name
                  </label>
                  <input
                    type="text"
                    value={formData.city}
                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    required
                  />
                </div>

                <div>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={formData.active}
                      onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                      className="mr-2"
                    />
                    <span className="text-sm font-medium text-gray-700">Active</span>
                  </label>
                </div>

                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      resetForm();
                    }}
                    className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                  >
                    {isEditing ? 'Update' : 'Create'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default City;
